import React, { FC } from "react";
import { useTranslations } from "next-intl";
import classNames from "classnames";

import { ShowWhen } from "@/components/common";
import { TCalculationResultProps } from "../types";
import { useTheme } from "@/context/Theme.context";
import { Theme } from "@/enums";
import { formatNumber } from "@/utils/formatNumber";

const CalculationResult: FC<TCalculationResultProps> = ({
  isSendParcel,
  calculationResult,
}) => {
  const theme = useTheme();
  const t = useTranslations();

  return (
    <div className="mt-6 flex w-full gap-3">
      <ShowWhen condition={!isSendParcel}>
        <div className="flex w-full max-w-[33%] flex-col items-start justify-center rounded-[18px] bg-[#ebebeb] px-4 py-3">
          <p className="text-xs font-medium text-black">
            {theme === Theme.UK ? t("taxes") : t("cost_of_custom_clearance")}
          </p>
          <p className="text-lg font-extrabold text-black">
            {theme === Theme.UZ ? t("uzs") : "$"}{" "}
            {formatNumber(calculationResult?.parcelDuty?.toFixed(2) || 0)}
          </p>
        </div>
      </ShowWhen>
      <div
        className={classNames(
          "secondary-bg flex w-full items-center justify-between gap-2.5 rounded-[18px] px-[17px] py-3",
          {
            "max-w-[67%]": !isSendParcel,
          },
        )}
      >
        <div>
          <p className="text-nowrap text-xs font-medium text-black">
            {t("transportation_price")}:{" "}
            {formatNumber(
              (
                calculationResult?.transportationPrice *
                calculationResult?.minWeight
              ).toFixed(2) || 0,
            )}{" "}
            {theme === Theme.UZ ? t("uzs") : "$"}
          </p>
          <ShowWhen condition={!isSendParcel}>
            <p className="text-nowrap text-xs font-medium text-black">
              {t("cost_of_additional_services")}:{" "}
              {formatNumber(
                calculationResult?.additionalServicesPrice.toFixed(2),
              ) || 0}{" "}
              {theme === Theme.UZ ? t("uzs") : "$"}
            </p>
          </ShowWhen>
        </div>
        <div
          className={classNames("w-full border-[0.5px]", {
            "max-w-[39%]": !isSendParcel,
            "max-w-[60%]": isSendParcel,
            "border-[#ceeef3]": theme !== Theme.UK,
            "border-[#eb7623]": theme === Theme.UK,
          })}
        />
        <div>
          <p className="primary-color text-nowrap text-center text-sm font-medium">
            {t("total_cost")}
          </p>
          <p className="primary-color whitespace-nowrap text-lg font-extrabold">
            {theme === Theme.UZ ? t("uzs") : "$"}{" "}
            {formatNumber(calculationResult?.totalCost.toFixed(2) || 0)}
          </p>
        </div>
      </div>
    </div>
  );
};

export { CalculationResult };
